import type { Progress } from "../progress/model/progress";

export type LevelStatusKind = "not-started" | "in-progress" | "stamped";

export interface LevelStatus {
  readonly kind: LevelStatusKind;
  readonly clearedCount: number;
  readonly drillCount: number;
}

/**
 * `Progress.clearedDrills` は `${levelId}:${drillId}` という修飾キーで記録される規約
 * （呼び出し側の規約。演習合格時にこの形式で `withClearedDrill` を呼ぶ）。
 * この規約により、稽古の段（S-1）は `level-N.json` 全体を読まずに、manifestの
 * `drillCount` と `Progress` の前方一致だけで「つづき n / m」を算出できる。
 */
export function computeLevelStatus(
  levelId: string,
  drillCount: number,
  progress: Progress,
): LevelStatus {
  if (progress.stamps.has(levelId)) {
    return { kind: "stamped", clearedCount: drillCount, drillCount };
  }
  const prefix = `${levelId}:`;
  let clearedCount = 0;
  for (const key of progress.clearedDrills) {
    if (key.startsWith(prefix)) {
      clearedCount += 1;
    }
  }
  return { kind: clearedCount > 0 ? "in-progress" : "not-started", clearedCount, drillCount };
}
